<template>
    <div class="col-lg-12 mt-3">
        <div class="row">
            <div class="col-lg-12 d-flex justify-content-end">
                <button v-show="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || (pOrigen=='SolicitudExtra')" @click="AbrirModal" class="btn btn-primary">Agregar Herramienta</button>
            </div>
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th v-if="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || pOrigen=='SolicitudExtra'"></th>
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>Cantidad de Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Herramientas" :key="index">
                                <td v-if="ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || pOrigen=='SolicitudExtra'">
                                    <button @click="EliminarHerramienta(item.IdMaterial)" class="btn btn-danger">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <!-- <td v-if="ObjSolicitudAlmacen.IdSolicitudAlmacen==undefined" style="width:70%">{{ item.Nombre }}</td>
                                <td v-else style="width:70%">{{ item.herramientas.Nombre }}</td> -->
                                <td style="width:70%">{{ item.Nombre }}</td>
                                <td>{{ ObjSolicitudAlmacen.IdSolicitudAlmacen==0 || pOrigen=='SolicitudExtra' ? item.Stock : item.StockAnterior }}</td>
                                <td>{{ item.CantidadSalida }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- <div class="table-responsive" v-show="this.ObjSolicitudAlmacen.IdSolicitudAlmacen!=0 && (this.ObjSolicitudAlmacen.Estatus=='Autorizada' || this.ObjSolicitudAlmacen.Estatus=='Finalizada')">
                    <h4>Salidas</h4>
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>¿Salió?</th>
                                <th>Salida</th>
                                <th>Observacion Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Herramientas" :key="index">
                                <td style="width:70%">{{ item.herramientas.Nombre }}</td>
                                <td>{{ item.StockAnterior }}</td>
                                <td>{{item.SalidaCheck==0 ? 'No' : 'Si'}}</td>
                                <td>{{ item.CantidadSalida }}</td>
                                <td><textarea class="form-control" name="" id="" cols="30" rows="2" v-model="item.ComentarioSalida" disabled></textarea></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="table-responsive" v-show="this.ObjSolicitudAlmacen.IdSolicitudAlmacen!=0 && this.ObjSolicitudAlmacen.Estatus=='Finalizada'">
                    <h4>Entradas</h4>
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Entradas</th>
                                <th>Estatus Entrada</th>
                                <th>Observación Entrada</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudAlmacen.Herramientas" :key="index">
                                <td style="width:70%">{{ item.herramientas.Nombre }}</td>
                                <td>{{ item.CantidadEntrada }}</td>
                                <td>{{ item.EstatusEntrada }}</td>
                                <td><textarea class="form-control" name="" id="" cols="30" rows="2" v-model="item.ComentarioEntrada" disabled></textarea></td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Herramientas',
    props:['pObjSolicitudAlmacen','pOrigen'],
    data() {
        return {
            ObjSolicitudAlmacen:{}
        }
    },
    methods: {
        AgregarHerramienta(item)
        {
            let ObjLista={
                IdMaterial: item.IdMaterial,
                Nombre: item.Nombre,
                Stock: item.Stock,
                CantidadSalida: item.CantidadSalida,
                Disabled: item.Disabled,
                Check: item.Check
            }
            this.ObjSolicitudAlmacen.Herramientas.push(ObjLista);
        },
        EliminarHerramienta(Id)
        {
            let index=this.ObjSolicitudAlmacen.Herramientas.findIndex((element)=>element.IdMaterial == Id);
            this.ObjSolicitudAlmacen.Herramientas.splice(index,1);
        },
        AbrirModal(){
            this.bus.$emit('AbrirModalHerramienta');
        }
    },
    created() {
        this.bus.$off('ArrayHerramientas');
        this.bus.$on('ArrayHerramientas',()=> {
            this.ObjSolicitudAlmacen = this.pObjSolicitudAlmacen;
        });

        // console.log(this.ObjSolicitudAlmacen.IdSolicitudAlmacen);
        
        this.ObjSolicitudAlmacen = this.pObjSolicitudAlmacen;

        this.bus.$off('AgregarHerramientaModal');
        this.bus.$on('AgregarHerramientaModal',(obj)=>{
            this.AgregarHerramienta(obj);
        })
    },
}
</script>

<style>

</style>